import React, { useMemo } from 'react';
import '../styles/TableExample.css';

const employeeData = [
  { id: 104, name: 'John Doe', age: 28, city: 'New York' },
  { id: 217, name: 'Jane Smith', age: 34, city: 'Los Angeles' },
  { id: 153, name: 'Sam Wilson', age: 23, city: 'Chicago' },
  { id: 389, name: 'Lisa Johnson', age: 29, city: 'San Francisco' },
  { id: 276, name: 'Mike Brown', age: 41, city: 'Seattle' },
  { id: 198, name: 'Sara Lee', age: 37, city: 'Miami' },
  { id: 342, name: 'Tom Harris', age: 22, city: 'Boston' },
  { id: 465, name: 'Emily Davis', age: 33, city: 'Dallas' },
  { id: 129, name: 'Robert White', age: 40, city: 'Austin' },
  { id: 581, name: 'Nancy Green', age: 31, city: 'Denver' },
  { id: 423, name: 'Chris Martin', age: 27, city: 'Phoenix' },
  { id: 356, name: 'Priya Sharma', age: 35, city: 'Hyderabad' },
];

const shuffleRows = (rows) => {
  const shuffled = [...rows];

  for (let index = shuffled.length - 1; index > 0; index -= 1) {
    const randomIndex = Math.floor(Math.random() * (index + 1));
    [shuffled[index], shuffled[randomIndex]] = [shuffled[randomIndex], shuffled[index]];
  }

  return shuffled;
};

const TableExample = () => {
  const tableData = useMemo(() => shuffleRows(employeeData), []);

  return (
    <div className="table-example">
      <header className="table-example-header">
        <h1 className="table-example-heading">Employee Table</h1>
        <p className="table-example-description">
          Row order changes on each page load. Practice locating values that can appear in any row.
        </p>
      </header>

      <div className="table-container">
        <table id="employee-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Age</th>
              <th>City</th>
            </tr>
          </thead>
          <tbody>
            {tableData.map((row) => (
              <tr key={row.id} id={`employee-row-${row.id}`}>
                <td>{row.id}</td>
                <td>{row.name}</td>
                <td>{row.age}</td>
                <td>{row.city}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TableExample;
